export function createSpyContext(ctx) {
    return {
        spy: (o) => ctx.spy(o.__INTERNAL_DO_NOT_USE_ATOM__),
    };
}
export function createGetContext(ctx) {
    return {
        get: (o) => ctx.get(o.__INTERNAL_DO_NOT_USE_ATOM__),
    };
}
